new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
      
    },
})

$(document).ready(function () {

  if (window.matchMedia("(max-width: 991px)").matches) {
      const sectionFooter = document.querySelectorAll('.section-footer');
      if (sectionFooter.length) {
          sectionFooter.forEach(section => {
              const footerTitle = section.querySelector('.footer-title');
              if (footerTitle) {
                  footerTitle.addEventListener('click', () => {
                      section.classList.toggle('active');
                  });
              }
          });
      }
  }

});